module.exports = __webpack_public_path__ + "img/hzhs3.7d7fa770.jpg";